import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22typography.ts%22,%22import%22:%22%22,%22arguments%22:[{%22adjustFontFallback%22:%22Arial%22,%22display%22:%22swap%22,%22src%22:[{%22path%22:%22./soehne-buch.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22}]}],%22variableName%22:%22soehne%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'soehne', 'soehne Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
